import { mapGetters } from 'vuex';
import Schema from '@/common/components/schemas/json-schema.vue';

export default {
    name: 'mvtBreadcrumb',
    root: true,
    components: { Schema },
    props: {
        isActive: {
            type: Boolean,
            default: true,
        },
        geo: {
            type: Object,
            default: null,
        },
        contentVariant: {
            type: Object,
            default: {},
        },
        forceSitemapPath: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapGetters('glb', ['glb', 'getSplit']),
        breadCrumbSuffix() {
            return this.glb.rentals && ['vdpp', 'vmapsearch'].includes(this.glb.pageType) ? ' Rentals' : '';
        },
        isBreadcrmbScriptHide() {
            return this.$route.path && this.$route.path.indexOf('/for-sale/') >= 0;
        },
        breadCrumbSchema() {
            const dataArr = [
                {
                    id: `${this.glb.appUrl}${this.isES ? 'es/' : ''}`,
                    name: 'Real Estate',
                },
                ...(this.geo.statePath
                    ? [
                          {
                              id: this.glb.appUrl + this.getPath('statePath'),
                              name: this.geo.stateFullName,
                          },
                      ]
                    : []),
                ...(this.geo.countyPath
                    ? [
                          {
                              id: this.glb.appUrl + this.getPath('countyPath'),
                              name: this.geo.county,
                          },
                      ]
                    : []),
                ...(this.geo.cityPath
                    ? [
                          {
                              id: this.glb.appUrl + this.getPath('cityPath'),
                              name: this.geo.city,
                          },
                      ]
                    : []),
                ...(this.geo.zipcodePath
                    ? [
                          {
                              id: this.glb.appUrl + this.getPath('zipcodePath'),
                              name: this.geo.zipcode,
                          },
                      ]
                    : []),
                ...(this.geo.neighborhoodPath && this.geo.neighborhood
                    ? [
                          {
                              id: this.glb.appUrl + this.getPath('neighborhoodPath'),
                              name: this.geo.neighborhood,
                          },
                      ]
                    : []),
            ];

            let schemaObj = {
                '@context': 'https://schema.org',
                '@type': 'BreadcrumbList',
                itemListElement: dataArr.map((element, index) => {
                    return {
                        '@type': 'ListItem',
                        position: index + 1,
                        item: {
                            '@id': element.id,
                            name: element.name,
                        },
                    };
                }),
            };
            return JSON.stringify(schemaObj);
        },
        isES() {
            return this.glb.requestUrlRaw && this.glb.requestUrlRaw.indexOf('/es/') === 0;
        },
        esPrefix() {
            return this.isES ? 'Casas en venta en' : '';
        },
    },
    methods: {
        getPath(key) {
            let path = (this.geo && this.geo[key]) || '';
            path = path.replace(/sitemap\//g, '').replace('homes-for-sale/', '');
            if (this.isES) {
                path = 'es/' + path;
            }
            return path;
        },
    },
};
